// IWEB-4523
// Experiment to provide temporary chain support for Spain.
// Will be removed when full solution is implemented.
// Applies to 'data-specific-location-required' attributes and asks for their Address.
// It will then either redirect to the menu page or deny based on polygon data.

import AttributeBinding from '../../modules/AttributeBinding';
import MegaModal from '../../modules/MegaModal';
import AddressLookup from '../../modules/AddressLookup';
import GeoLocationCookies from '../../modules/geoLocationCookies';
import { fetchJSON } from '../../helpers/fetchHelper';
import { experimentLogger } from '../../logger';

const filename = 'specificlocationrequired.js';

// Functional Wrappers around External Services.
// RestaurantsFilterRepository Should be extracted at some point and shared between search Experiment.

const restaurantsFilterRepository = {
    search: (options) => fetchJSON(`/area/filter-restaurants/${options.area}?lat=${options.lat}&long=${options.long}`)
};

function showAddressModal (selector) {
    return new Promise((success) => {
        AddressLookup.getAddressFromUser(selector,
            success,
            {
                modal: {
                    clickOutsideToClose: 'false'
                },
                addressLookup: {
                    leaveModalOpenOnComplete: true
                }
            });
    });
}

function openModal (o) {
    return new MegaModal(o);
}

function getAvailableRestaurant (restaurantListing, options) {
    if (restaurantListing) {
        let availableRestaurants = [];
        if (options.base.isOpen.toString().toLowerCase() === 'true' && restaurantListing.openRestaurants) {
            availableRestaurants = options.base.restaurants
                .filter(r => restaurantListing.openRestaurants.some(or => or.Id === r.id));
        } else if (restaurantListing.closedRestaurants) {
            availableRestaurants = options.base.restaurants
                .filter(r => restaurantListing.closedRestaurants.some(or => or.Id === r.id));
        }

        if (availableRestaurants.length > 0) {
            return {
                canDeliver: true,
                deliveryUrl: availableRestaurants[0].forwardUrl
            };
        }
    }

    return { canDeliver: false };
}


function canRestaurantDeliverToUser (restaurants, options, locationData, callback) {
    return new Promise((success) => {
        restaurants.search({
            area: locationData.postCode,
            lat: locationData.latitude,
            long: locationData.longitude
        })
            .then(results => {
                var par = getAvailableRestaurant(results, options);
                if (callback) {
                    callback(par);
                }
                success(par);
            })
            .catch(() => {
                if (callback) {
                    callback({ canDeliver: false });
                }
                success({ canDeliver: false });
            });
    });
}

function redirectToUrl (window, url) {
    window.location.href = url;
}

function openApologyModal (doc, modalCreator) {
    const modalSelector = '[data-cant-deliver-to-lat-long]';
    const closeSelector = '[data-close-modal]';
    const modal = modalCreator({
        content: modalSelector,
        className: '',
        clickOutsideToClose: true,
        buttons: '[]',
        afterShow: () => doc.querySelectorAll(closeSelector).forEach(el => el.addEventListener('click', modal.hide))
    });
    modal.show();
    return modal;
}

function validateOptions (options) {
    if (!options.base) {
        throw new Error('Options cannot be empty');
    }

    if (!options.base.restaurants) {
        throw new Error('RestaurantIds cannot be empty');
    }

    if (options.base.isOpen === undefined) {
        throw new Error('isOpen cannot be empty');
    }
}

function disableAddressModal (modal) {
    const btn = modal.el.querySelector('[data-address-lookup-search-button]');
    const input = modal.el.querySelector('[data-address-lookup-full-address]');
    btn.disabled = true;
    btn.classList.add('is-loading', 'is-loading--light', 'is-loading--small');
    btn.style.width = `${btn.offsetWidth}px`;
    btn.textContent = '';
    input.disabled = true;
}

function getLocationFromUser (window, doc, getAddressFromUser, geoCookies, restaurants, modalCreator, options, successCallback, failureCallback) {
    validateOptions(options);
    getAddressFromUser('[data-delivery-checker]')
        .then(data => {
            disableAddressModal(data.modal.modal);
            geoCookies.set({
                latitude: data.location.latitude,
                longitude: data.location.longitude,
                street: data.location.street,
                streetNumber: data.location.streetNumber,
                city: data.location.locality,
                postCode: data.location.postCode
            });
            return canRestaurantDeliverToUser(restaurants, options, data.location, () => data.modal.hide());
        })
        .then(result => {
            if (result.canDeliver) {
                if (successCallback) {
                    successCallback();
                } else {
                    redirectToUrl(window, result.deliveryUrl);
                }
            } else if (failureCallback) {
                failureCallback();
            } else {
                openApologyModal(doc, modalCreator);
            }
        });
}

function getOptions (restId, isOpen) {
    return {
        base: {
            restaurants: [{ id: parseInt(restId, 10) }],
            isOpen
        }
    };
}

export function canDeliverToLastUsedLocation (restId, isOpen, callback) {
    const options = getOptions(restId, isOpen);
    const location = GeoLocationCookies.get();
    if (!(location.postCode && location.latitude && location.longitude && location.street && location.streetNumber)) {
        callback({ canDeliver: false });
        return;
    }
    canRestaurantDeliverToUser(restaurantsFilterRepository, options, location, callback);
}

export function getGPLocation (restId, isOpen, successCallback, failureCallback) {
    const options = getOptions(restId, isOpen);
    try {
        getLocationFromUser(window,
            document,
            showAddressModal,
            GeoLocationCookies,
            restaurantsFilterRepository,
            openModal,
            options,
            successCallback,
            failureCallback);
    } catch (err) {
        experimentLogger.error(filename, 'error getting location from user', err);
    }
}

window.Experiment = window.Experiment || {};
window.Experiment.IWEB4523 = {};
window.Experiment.IWEB4523.getGPLocation = getGPLocation;
window.Experiment.IWEB4523.canDeliverToLastUsedLocation = canDeliverToLastUsedLocation;

AttributeBinding.bindOnAttribute(
    'data-specific-location-required',
    (element, options) => {
        element.addEventListener('click',
            event => {
                event.preventDefault();
                try {
                    getLocationFromUser(window,
                        document,
                        showAddressModal,
                        GeoLocationCookies,
                        restaurantsFilterRepository,
                        openModal,
                        options);
                } catch (err) {
                    experimentLogger.error(filename, 'error getting location from user', err);
                }
            });
    }
);


